// extracted by mini-css-extract-plugin
module.exports = {"captionsContainer":"AudioCaptions_captionsContainer__39GUQ","captionTrack":"AudioCaptions_captionTrack__3UyKg"};